require('bootstrap')
require('bootstrap/dist/css/bootstrap.min.css')
require('@fortawesome/fontawesome-pro/css/fontawesome.min.css')
require('@fortawesome/fontawesome-pro/css/solid.min.css')
require('../css/style.css')
require('../css/responsive.css')

require('../img/great-bg.png')
require('../img/logo.svg')
require('../img/outbound-link.png')
require('../img/favicon.png')

document.addEventListener('DOMContentLoaded', () => {
    let anchors = document.querySelectorAll('#nav-selector a');
    let sections = document.querySelectorAll('.demand__wrapper');
    function hashchange() {
        if (window.location.hash === '#rex' || window.location.hash === '#sample') {
            for (let s of sections) {
                s.classList.remove('visible');
            }
            document.getElementById(window.location.hash.substring(1)).classList.add('visible');

            for (let a of anchors) {
                a.classList.remove('selected');
            }
            document.querySelector(`a[href="${window.location.hash}"]`).classList.add('selected');
        }
    }

    window.addEventListener("hashchange", hashchange);
    hashchange();
});
